/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "from-device-info"
};
var _hoisted_2 = {
  class: "list-detail"
};
var _hoisted_3 = {
  class: "list-detail-block"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "基本信息")], -1);
var _hoisted_5 = {
  class: "detail-item-content"
};
var _hoisted_6 = {
  class: "content-item"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "保养内容:", -1);
var _hoisted_8 = {
  class: "content-item-value"
};
var _hoisted_9 = {
  class: "content-item"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "保养人:", -1);
var _hoisted_11 = {
  class: "content-item-value"
};
var _hoisted_12 = {
  class: "content-item"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "计划保养时间:", -1);
var _hoisted_14 = {
  class: "content-item-value"
};
var _hoisted_15 = {
  class: "content-item"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务类型:", -1);
var _hoisted_17 = {
  class: "content-item-value"
};
var _hoisted_18 = {
  class: "content-item"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务状态:", -1);
var _hoisted_20 = {
  class: "content-item-value"
};
var _hoisted_21 = {
  key: 0,
  class: "tag-ing tag"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "进行中", -1);
var _hoisted_23 = [_hoisted_22];
var _hoisted_24 = {
  key: 1,
  class: "tag-cancel tag"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "已取消", -1);
var _hoisted_26 = [_hoisted_25];
var _hoisted_27 = {
  key: 2,
  class: "tag-cancel tag"
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "未开始", -1);
var _hoisted_29 = [_hoisted_28];
var _hoisted_30 = {
  key: 3,
  class: "tag-expect tag"
};
var _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "已逾期", -1);
var _hoisted_32 = [_hoisted_31];
var _hoisted_33 = {
  key: 4,
  class: "tag-complete tag"
};
var _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "已完成", -1);
var _hoisted_35 = [_hoisted_34];
var _hoisted_36 = {
  class: "content-item"
};
var _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "开始时间:", -1);
var _hoisted_38 = {
  class: "content-item-value"
};
var _hoisted_39 = {
  class: "content-item"
};
var _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "结束时间:", -1);
var _hoisted_41 = {
  class: "content-item-value"
};
var _hoisted_42 = {
  class: "content-item"
};
var _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "创建时间:", -1);
var _hoisted_44 = {
  class: "content-item-value"
};
var _hoisted_45 = {
  class: "list-detail-block list-detail-block_2"
};
var _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "保养情况")], -1);
var _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-label"
}, "图片", -1);
var _hoisted_48 = {
  class: "bottom-submit"
};
import { findTaskItemInfo } from '@/service/patrolScheme/index';
import { uploadImage, delImage, delPatrolGuard, postAddPatrolGuard, cancelPatrolGuard } from '@/service/patrolGuard/index';
import { showToast } from 'vant';
import './common.less';
import './fromDeviceInfo.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'fromDeviceInfo',
  setup: function setup(__props) {
    // import ContentPage from '@/components/ContentPage/index.vue';
    var router = useRouter();
    var route = useRoute();
    var _route$query = route.query,
      id = _route$query.id,
      taskItemId = _route$query.taskItemId;
    var inspectionResult = ref('');
    var formRef = ref('');
    var imgList = ref([]);
    var inspectionContent = ref('');
    var loading = ref(false);
    var imgIdList = ref([]);
    var delLoading = ref(false);
    var cancelloading = ref(false);
    var baseInfo = ref('');
    // 上传图片
    var ImgUploadFile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileList) {
        var formData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 要把数据变成file格式
              formData = new FormData();
              fileList.map(function (item) {
                formData.append('file', item.file);
              });
              _context.next = 5;
              return uploadImage(formData);
            case 5:
              data = _context.sent;
              return _context.abrupt("return", Promise.resolve(data.list));
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", Promise.reject());
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function ImgUploadFile(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var beforeRead = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var status, reg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              status = Array.isArray(file);
              reg = /png$|jpeg$|gif$|jpg$/;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var imgFlag = 0;
                if (status) {
                  file.map(function (item) {
                    if (!reg.test(item.type)) {
                      imgFlag++;
                    }
                  });
                } else {
                  if (!reg.test(file.type)) {
                    imgFlag++;
                  }
                }
                if (imgFlag) {
                  showToast('仅支持上传图片！');
                  return reject(false);
                }
                return resolve();
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function beforeRead(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var afterRead = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
        var status, list, fileList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              status = Array.isArray(file);
              _context3.prev = 1;
              list = [];
              if (!status) {
                _context3.next = 11;
                break;
              }
              fileList = [];
              file.map(function (item) {
                fileList.push(item);
                item.status = 'uploading';
                item.message = '上传中...';
              });
              _context3.next = 8;
              return ImgUploadFile(fileList);
            case 8:
              list = _context3.sent;
              _context3.next = 16;
              break;
            case 11:
              file.status = 'uploading';
              file.message = '上传中...';
              _context3.next = 15;
              return ImgUploadFile([file]);
            case 15:
              list = _context3.sent;
            case 16:
              list.map(function (item) {
                imgIdList.value.push(item.attachment_id);
              });
              if (status) {
                list.map(function (item, index) {
                  file[index].id = item.attachment_id;
                  file[index].message = '上传成功';
                  file[index].status = 'successed';
                });
              } else {
                file.id = list[0]['attachment_id'];
                file.message = '上传成功';
                file.status = 'successed';
              }
              showToast('上传成功');
              _context3.next = 25;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](1);
              file.status = 'failed';
              file.message = '上传失败';
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 21]]);
      }));
      return function afterRead(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var delImg = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file) {
        var index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              index = imgIdList.value.findIndex(function (item) {
                return item == (file === null || file === void 0 ? void 0 : file.id);
              });
              imgIdList.value.splice(index, 1);
              _context4.next = 5;
              return delImage(file === null || file === void 0 ? void 0 : file.id);
            case 5:
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      return function delImg(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    var onDel = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, timer;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              delLoading.value = true;
              _context5.next = 4;
              return delPatrolGuard(taskItemId);
            case 4:
              res = _context5.sent;
              if (res.status == '1') {
                showToast.success("\u5220\u9664\u6210\u529F");
              } else {
                showToast("\u5220\u9664\u5931\u8D25");
              }
              timer = setTimeout(function () {
                clearTimeout(timer);
                delLoading.value = false;
                router.back();
              }, 500);
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              delLoading.value = false;
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 9]]);
      }));
      return function onDel() {
        return _ref5.apply(this, arguments);
      };
    }();
    var onCancel = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res, timer;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              cancelloading.value = true;
              _context6.next = 4;
              return cancelPatrolGuard({
                id: Number(taskItemId),
                status: -1
              });
            case 4:
              res = _context6.sent;
              if (res.status == '1') {
                showToast.success("\u53D6\u6D88\u6210\u529F");
              } else {
                showToast("\u53D6\u6D88\u5931\u8D25");
              }
              timer = setTimeout(function () {
                clearTimeout(timer);
                cancelloading.value = false;
                router.back();
              }, 500);
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](0);
              cancelloading.value = false;
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 9]]);
      }));
      return function onCancel() {
        return _ref6.apply(this, arguments);
      };
    }();
    var onSubmit = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res, timer;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              loading.value = true;
              _context7.next = 4;
              return formRef.value.validate();
            case 4:
              _context7.next = 6;
              return postAddPatrolGuard({
                inspectionResult: Number(unref(inspectionResult)),
                taskType: 1,
                dateSource: 2,
                deviceId: Number(id),
                inspectionContent: inspectionContent.value,
                inspectionHistoryAttachmentIdList: imgIdList.value,
                inspectionItemId: taskItemId
              });
            case 6:
              res = _context7.sent;
              if (res.status == '1') {
                showToast.success("\u5B8C\u6210\u6210\u529F");
              } else {
                showToast("\u5B8C\u6210\u5931\u8D25");
              }
              timer = setTimeout(function () {
                clearTimeout(timer);
                loading.value = false;
                router.back();
              }, 500);
              _context7.next = 14;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](0);
              loading.value = false;
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 11]]);
      }));
      return function onSubmit() {
        return _ref7.apply(this, arguments);
      };
    }();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var infoRes;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return findTaskItemInfo(Number(taskItemId), Number(id));
          case 2:
            infoRes = _context8.sent;
            console.log(infoRes, 'infoRes');
            baseInfo.value = (infoRes === null || infoRes === void 0 ? void 0 : infoRes.data) || {};
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    })));
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_uploader = _resolveComponent("van-uploader");
      var _component_van_form = _resolveComponent("van-form");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(baseInfo).info || '--'), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(baseInfo).inspectionUserName || '--'), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(baseInfo).taskRuleTimeStr || '--'), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(baseInfo).taskRuleType || '--'), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_unref(baseInfo).status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)) : _createCommentVNode("", true), _unref(baseInfo).status == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26)) : _createCommentVNode("", true), _unref(baseInfo).status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29)) : _createCommentVNode("", true), _unref(baseInfo).status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32)) : _createCommentVNode("", true), _unref(baseInfo).status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(baseInfo).startTime || '--'), 1)]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(baseInfo).endTime || '--'), 1)]), _createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(baseInfo).createTime || '--'), 1)])])]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createVNode(_component_van_form, {
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            rows: "3",
            autosize: "",
            required: "",
            label: "保养情况",
            type: "textarea",
            placeholder: "请输入",
            modelValue: _unref(inspectionContent),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(inspectionContent) ? inspectionContent.value = $event : null;
            }),
            rules: [{
              required: true,
              message: '请输入保养情况'
            }]
          }, null, 8, ["modelValue"]), _hoisted_47, _createVNode(_component_van_field, {
            name: "uploader"
          }, {
            input: _withCtx(function () {
              return [_createVNode(_component_van_uploader, {
                modelValue: _unref(imgList),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(imgList) ? imgList.value = $event : null;
                }),
                "after-read": afterRead,
                "before-read": beforeRead,
                "max-count": "9",
                multiple: "",
                onDelete: delImg
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 512)])]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_van_button, {
        plain: "",
        round: "",
        block: "",
        type: "primary",
        class: "btn-1",
        onClick: onDel,
        loading: _unref(delLoading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 删除 ")];
        }),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_van_button, {
        plain: "",
        round: "",
        block: "",
        type: "primary",
        class: "btn-2",
        onClick: onCancel,
        loading: _unref(cancelloading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 取消 ")];
        }),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_van_button, {
        loading: _unref(loading),
        round: "",
        block: "",
        type: "primary",
        class: "btn-3",
        onClick: onSubmit
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 确定 ")];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});